import { render, staticRenderFns } from "./ProcessingOffers.vue?vue&type=template&id=23b0b472"
import script from "./ProcessingOffers.vue?vue&type=script&lang=js"
export * from "./ProcessingOffers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports